import { TellescopeModelFromName, useTellescopeQuery } from "@tellescope/tanstack-query";
import { cn } from "@tellescope/ui";

export interface TicketHeaderProps {
  ticketId: string;
  ticket?: TellescopeModelFromName<"tickets">;
  className?: string;
}

export const TicketHeader = ({ ticketId, ticket: providedTicket, className }: TicketHeaderProps) => {
  const ticketQuery = useTellescopeQuery({
    model: "tickets",
    method: "getOne",
    request: ticketId,
    enabled: !!ticketId && !providedTicket,
  });

  const ticket = providedTicket ?? ticketQuery.data;

  return <h2 className={cn(className)}>{ticket?.title}</h2>;
};
